import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LifegridMark } from "@/components/Logo";
import { toast } from "sonner";

export function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { completeSession } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      navigate("/", { replace: true });
      return;
    }
    (async () => {
      try {
        const user = await completeSession(sessionId);
        // clear the fragment so refresh doesn't re-run
        window.history.replaceState(null, "", "/");
        toast.success(`Welcome, ${user.name || user.email}`);
        navigate("/", { replace: true, state: { user } });
      } catch (e) {
        toast.error("Sign-in failed. Please try again.");
        navigate("/", { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[color:var(--lg-void)]">
      <LifegridMark size={56} />
      <div className="mt-6 font-mono-tac text-[11px] tracking-[0.28em] text-[color:var(--lg-cyan)]">
        <span className="live-dot inline-block align-middle mr-2" /> AUTHENTICATING…
      </div>
    </div>
  );
}
